import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from '../../../../hooks/useTranslation';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import UserIcon from '../icons/UserIcon';
import useAuth from '../../../../hooks/useAuth';
import HomeIcon from '../icons/HomeIcon';
import mainColors from '../../../../themes/main-colors';
import {
  ResponsivePageView,
  useOutageResponsivePageTracker,
} from '../../providers/OutageResponsivePageTracker';
import { navigate } from 'gatsby';
import routes from '../../../../routes';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: theme.spacing(2.5),
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
      cursor: 'pointer',
    },
    title: {
      fontWeight: 600,
    },
  }),
);
export const OutageView = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { isAuthenticated, isLoading } = useAuth();
  const { setPage } = useOutageResponsivePageTracker();
  const {
    setOutageMarkerView,
    setSinglePremiseInfo,
    setMultiPremiseInfo,
  } = useOutageLeftPanelState();

  return (
    <Grid container className={classes.root}>
      <Grid
        item
        className={classes.item}
        onClick={() => {
          setPage(ResponsivePageView.Map);
          setOutageMarkerView(undefined);
          setSinglePremiseInfo(undefined);
          setMultiPremiseInfo(undefined);
        }}
      >
        <ChevronLeftIcon />
        <Typography className={classes.title}>
          {t('BACK_TO_OUTAGE_MAP')}
        </Typography>
      </Grid>
      {!isLoading && !isAuthenticated && (
        <Grid
          item
          className={classes.item}
          onClick={() =>
            navigate(routes.SIGN_IN, {
              state: {
                redirectUrl: routes.OUTAGES,
              },
            })
          }
        >
          <Typography className={classes.title}>{t('SIGN_IN')}</Typography>
          <UserIcon size={26} />
        </Grid>
      )}
      {!isLoading && isAuthenticated && (
        <Grid
          item
          className={classes.item}
          onClick={() => {
            setPage(ResponsivePageView.Home);
            setOutageMarkerView(undefined);
            setSinglePremiseInfo(undefined);
            setMultiPremiseInfo(undefined);
          }}
        >
          <Typography className={classes.title}>{t('MY_ACCOUNT')}</Typography>
          <HomeIcon size={26} color={mainColors.pacificBlue} />
        </Grid>
      )}
    </Grid>
  );
};
